// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'emergency-contacts/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-emergency-contacts" */ '@/pages/[organisation]/hr/team-member-emergency-contacts/archived-team-member-emergency-contacts.vue'),
        name: 'human-resource.team-member-emergency-contacts.archived-team-member-emergency-contacts',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.emergency-contact.update-team-member-emergency-contact',
        },
    },
    {
        path: 'emergency-contacts/archive/:contactId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-emergency-contacts" */ '@/pages/[organisation]/hr/team-member-emergency-contacts/archived-team-member-emergency-contact/[id].vue'),
        name: 'human-resource.team-member-emergency-contacts.view-archived-team-member-emergency-contact',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.emergency-contact.update-team-member-emergency-contact',
        },
    },

    {
        path: 'emergency-contacts',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-emergency-contacts" */ '@/pages/[organisation]/hr/team-member-emergency-contacts/team-member-emergency-contacts.vue'),
        name: 'human-resource.team-member-emergency-contacts.search-team-member-emergency-contacts',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.emergency-contact.view-team-member-emergency-contacts',
        },
    },
    {
        path: 'emergency-contacts/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-emergency-contacts" */ '@/pages/[organisation]/hr/team-member-emergency-contacts/team-member-emergency-contact/new.vue'),
        name: 'human-resource.team-member-emergency-contacts.create-team-member-emergency-contact',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.emergency-contact.create-team-member-emergency-contact',
        },
    },
    {
        path: 'emergency-contacts/:contactId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-emergency-contacts" */ '@/pages/[organisation]/hr/team-member-emergency-contacts/team-member-emergency-contact/[id].vue'),
        name: 'human-resource.team-member-emergency-contacts.view-team-member-emergency-contact',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.emergency-contact.view-team-member-emergency-contacts',
        },
    },
    {
        path: 'emergency-contacts/:contactId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-emergency-contacts" */ '@/pages/[organisation]/hr/team-member-emergency-contacts/team-member-emergency-contact/[id]/edit.vue'),
        name: 'human-resource.team-member-emergency-contacts.update-team-member-emergency-contact',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.emergency-contact.update-team-member-emergency-contact',
        },
    },
];
